namespace TabAurous.Production {
    export interface ReceiptMaterialRow {
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        BagNo?: string;
        Line_No?: number;
        Pieces?: number;
        DepartmentId?: number;
        UserId?: number;
        Username?: string;
        EmployeeId?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        Details?: ReceiptMaterialDetailsRow[];
        ProductCode?: string;
        ImageName?: string;
    }

    export namespace ReceiptMaterialRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Production.ReceiptMaterial';
        export const deletePermission = 'Production:ReceiptMaterial:Delete';
        export const insertPermission = 'Production:ReceiptMaterial:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:ReceiptMaterial:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            BagNo = "BagNo",
            Line_No = "Line_No",
            Pieces = "Pieces",
            DepartmentId = "DepartmentId",
            UserId = "UserId",
            Username = "Username",
            EmployeeId = "EmployeeId",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            Details = "Details",
            ProductCode = "ProductCode",
            ImageName = "ImageName"
        }
    }
}
